/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type InvoiceFilterButton_project = {
    readonly id: string;
    readonly " $refType": "InvoiceFilterButton_project";
};
export type InvoiceFilterButton_project$data = InvoiceFilterButton_project;
export type InvoiceFilterButton_project$key = {
    readonly " $data"?: InvoiceFilterButton_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"InvoiceFilterButton_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvoiceFilterButton_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = '039e698c963209de9dff18bd632f751c';
export default node;
